import { createSelector } from '@ngrx/store';

import * as KpiNotificationReducer from './kpi-notification-settings.reducer';
import { getKpiNotificationSettingsState } from './kpi-notification-settings.reducer';

export const getKpiNotificationsState = createSelector(getKpiNotificationSettingsState, (state) => state);
export const getKpiNotificationSettings = createSelector(
    getKpiNotificationsState,
    (state: KpiNotificationReducer.State) => state.kpiNotificationSettings,
);
export const getLoaded = createSelector(
    getKpiNotificationsState,
    (state: KpiNotificationReducer.State) => state.loaded,
);
